import { createAction } from '../../../store.model';
import { ActionType } from '../landing.action';
import { GridType } from '../model/grid-type.model';

export interface ToggleGridShowAll {
    type: GridType;

    /** specify this value to override the toggle */
    showAll?: boolean;
}

export const toggleGridShowAll = createAction<ActionType, ToggleGridShowAll>(
    ActionType.EVAL_LANDING__TOGGLE_GRID_SHOW_ALL,
);
